import { PackageType } from '@retail/products/types';
import { PriceType } from '../Conditions';
import { ConditionBaseProps, ItemConditionBase } from '../ConditionBase';
import { CalculusConditionDTO } from '../../dtos';
import { dateFromString } from '@retail/utils';
import { SupplierBase } from '@retail/suppliers/types';

interface PurchaseConditionProps extends ConditionBaseProps<PurchaseCondition> {
  purchaseAgreementText?: string;
  purchaseAgreementNumber?: string;
  purchaseAgreementId?: number;
  purchasePriceType?: PriceType;
  purchasePackageType?: PackageType;
  agreementText?: string;
  supplierAgreementId?: string;
}

export class PurchaseCondition extends ItemConditionBase<PurchaseCondition> {
  purchaseAgreementText?: string;
  purchaseAgreementNumber?: string;
  purchaseAgreementId?: number;
  purchasePriceType?: PriceType;
  purchasePackageType?: PackageType;
  agreementText?: string;
  supplierAgreementId?: string;

  constructor({
    purchaseAgreementText,
    purchaseAgreementNumber,
    purchaseAgreementId,
    purchasePriceType,
    purchasePackageType,
    agreementText,
    supplierAgreementId,
    ...superProps
  }: PurchaseConditionProps) {
    if (
      !(agreementText || purchaseAgreementText || purchaseAgreementNumber || supplierAgreementId)
    ) {
      throw new Error(
        `Condition id: ${superProps.id} is missing agreement fields: ${
          agreementText || purchaseAgreementText ? '' : 'agreementText'
        }, ${supplierAgreementId || purchaseAgreementNumber ? '' : 'supplierAgreementId'}`
      );
    }
    super(superProps);
    this.purchaseAgreementText = purchaseAgreementText;
    this.purchaseAgreementNumber = purchaseAgreementNumber;
    this.purchaseAgreementId = purchaseAgreementId;
    this.purchasePriceType = purchasePriceType;
    this.purchasePackageType = purchasePackageType;
    this.agreementText = agreementText;
    this.supplierAgreementId = supplierAgreementId;
  }

  static fromDto = (dto: CalculusConditionDTO): PurchaseCondition =>
    new PurchaseCondition({
      id: dto.id,
      assortmentId: dto.assortmentId,
      assortmentName: dto.assortmentName,
      inDraft: dto.inDraft,
      type: dto.type,
      supplier: dto.supplier ? SupplierBase.fromDto(dto.supplier) : undefined,
      bindingType: dto.bindingType,
      bindingTarget: dto.bindingTarget,
      bindingTargetName: dto.bindingTargetName,
      bindingTargetId: dto.bindingTargetId,
      bindingTargetItem: dto.bindingTargetItem,
      validFrom: new Date(dto.validFrom),
      validTo: dateFromString(dto.validTo),
      purchaseAgreementText: dto.purchaseAgreementText,
      purchaseAgreementNumber: dto.purchaseAgreementNumber,
      purchaseAgreementId: dto.purchaseAgreementId,
      purchasePriceType: dto.purchasePriceType,
      purchasePackageType: dto.purchasePackageType,
      agreementText: dto.agreementText,
      supplierAgreementId: dto.supplierAgreementId,
    });
}
